var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "field has-addons" }, [
    _vm.readOnly
      ? _c("p", { staticClass: "control is-expanded" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.vendorText,
                expression: "vendorText",
              },
            ],
            staticClass: "input is-static",
            attrs: { readonly: "readonly", type: "text" },
            domProps: { value: _vm.vendorText },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.vendorText = $event.target.value
              },
            },
          }),
        ])
      : _c(
          "p",
          { staticClass: "control is-expanded" },
          [
            _vm.vendors
              ? _c(
                  "multiselect",
                  {
                    class: { "is-danger": _vm.$v.entity.vendor.$error },
                    attrs: {
                      value: _vm.value,
                      "deselect-label": "Can't remove this value",
                      "track-by": "key",
                      label: "value",
                      placeholder: "Select a vendor",
                      options: _vm.vendors,
                      loading: _vm.isVendorLoading,
                      "internal-search": false,
                      "options-limit": _vm.assetFilter.pageSize,
                      searchable: true,
                      "show-labels": false,
                      "allow-empty": true,
                    },
                    on: {
                      input: _vm.changeVendor,
                      "search-change": _vm.searchVendor,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "option",
                          fn: function (props) {
                            return [
                              _c("span", [_vm._v(_vm._s(props.option.value))]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2400269036
                    ),
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "has-text-danger",
                        attrs: { slot: "noResult" },
                        slot: "noResult",
                      },
                      [_vm._v("Vendor not found.")]
                    ),
                  ]
                )
              : _vm._e(),
            !_vm.$v.entity.vendor.required
              ? _c("span", { staticClass: "help is-danger" }, [
                  _vm._v("Vendor is required"),
                ])
              : _vm._e(),
          ],
          1
        ),
    _vm.isNew
      ? _c("p", { staticClass: "control" }, [
          _vm.vendorId === ""
            ? _c(
                "a",
                {
                  staticClass: "button is-primary tooltip",
                  attrs: { "data-tooltip": "Add vendor" },
                  on: { click: _vm.addVendor },
                },
                [_vm._m(0)]
              )
            : _vm._e(),
          _vm.vendorId !== ""
            ? _c(
                "a",
                {
                  staticClass: "button is-success tooltip",
                  attrs: { "data-tooltip": "Edit vendor" },
                  on: { click: _vm.editVendor },
                },
                [_vm._m(1)]
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-plus mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-pencil mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }